export enum LoyaltyType{
    NONE,
    MARKETPLACE,
    AUCTION,
    LOTTO
}